import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { retry, catchError } from "rxjs/operators";
import { Observable, throwError } from "rxjs";
import { environment } from "../../../environments/environment";
@Injectable({
  providedIn: "root",
})
export class ReportService {
  baseUrl = environment.apiUrl;
  urlExtenssion = localStorage.getItem("urlExtenssion");

  constructor(private http: HttpClient) { }
  updateUrlExtention() {
    this.urlExtenssion = localStorage.getItem("urlExtenssion");
    if (this.urlExtenssion == null) {
      this.urlExtenssion = "";
    }
  }

  // commission report
  getTrainerMonthlyAmountReport(date) {
    this.updateUrlExtention();
    return this.http.get(
      this.baseUrl +
      `backoffice${this.urlExtenssion}/monthlyAmountReport/getTrainerMonthlyAmountReport?date=${date}`
    );
  }
  getTrainerMonthlyAmountReportYears() {
    this.updateUrlExtention();
    return this.http.get(
      this.baseUrl +
      `backoffice${this.urlExtenssion}/monthlyAmountReport/getTrainerMonthlyAmountReportYears`
    );
  }
  getTrainerMonthlyAmountReportFilter(fromDate, toDate, locationId) {
    this.updateUrlExtention();
    return this.http.get(
      this.baseUrl +
      `backoffice${this.urlExtenssion}/reports/getIsPrivateReportFilter?from_date=${fromDate}&to_date=${toDate}&location_id=${locationId}`
    );
  }

  // walkins report
  getWalkinsMonthlyAmountReport(date) {
    this.updateUrlExtention();
    return this.http.get(
      this.baseUrl +
      `backoffice${this.urlExtenssion}/monthlyAmountReport/getWalkinsMonthlyAmountReport?date=${date}`
    );
  }
  getWalkinsMonthlyAmountReportYears() {
    this.updateUrlExtention();
    return this.http.get(
      this.baseUrl +
      `backoffice${this.urlExtenssion}/monthlyAmountReport/getWalkinsMonthlyAmountReportYears`
    );
  }
  getWalkinsMonthlyAmountReportFilter(fromDate, toDate, locationId) {
    this.updateUrlExtention();
    return this.http.get(
      this.baseUrl +
      `backoffice${this.urlExtenssion}/reports/getWalkinsReportFilter?from_date=${fromDate}&to_date=${toDate}&location_id=${locationId}`
    );
  }

  // new trainee report
  getNewTraineeReport() {
    this.updateUrlExtention();
    return this.http.get(
      this.baseUrl +
      `backoffice${this.urlExtenssion}/monthlyAmountReport/getNewTraineeReport`
    );
  }
  getNewTraineeReportFilter(fromDate, toDate) {
    this.updateUrlExtention();
    return this.http.get(
      this.baseUrl +
      `backoffice${this.urlExtenssion}/reports/getNewTraineeReportFilter?from_date=${fromDate}&to_date=${toDate}`
    );
  }

  // get renewal report
  getRenewalReport(date) {
    this.updateUrlExtention();
    return this.http.get(
      this.baseUrl +
      `backoffice${this.urlExtenssion}/monthlyAmountReport/getRenewalReport?date=${date}`
    );
  }
  getRenewalReportYears() {
    this.updateUrlExtention();
    return this.http.get(
      this.baseUrl +
      `backoffice${this.urlExtenssion}/monthlyAmountReport/getRenewalReportYears`
    );
  }
  getRenewalReportFilter(fromDate, toDate, locationId) {
    this.updateUrlExtention();
    return this.http.get(
      this.baseUrl +
      `backoffice${this.urlExtenssion}/reports/getRenewalReportFilter?from_date=${fromDate}&to_date=${toDate}&location_id=${locationId}`
    );
  }

  //credit report
  getMonthlyAmountReport() {
    this.updateUrlExtention();
    return this.http.get(
      this.baseUrl +
      `backoffice${this.urlExtenssion}/monthlyAmountReport/getMonthlyAmountReportAllMonths`
    );
  }
  getMonthlyAmountReportFilter(fromDate, toDate, locationId) {
    this.updateUrlExtention();
    return this.http.get(
      this.baseUrl +
      `backoffice${this.urlExtenssion}/reports/getCreditReportFilter?from_date=${fromDate}&to_date=${toDate}&location_id=${locationId}`
    );
  }
  getMembershipCreditReportFilter(fromDate, toDate, locationId) {
    this.updateUrlExtention();
    return this.http.get(
      this.baseUrl +
      `backoffice${this.urlExtenssion}/reports/getMemberShipCreditReportFilter?from_date=${fromDate}&to_date=${toDate}&location_id=${locationId}`
    );
  }

  // trainer commission report
  getIsPrivateReportFilterForServices(fromDate, toDate, locationId) {
    this.updateUrlExtention();
    return this.http.get(
      this.baseUrl +
      `backoffice${this.urlExtenssion}/reports/getIsPrivateReportFilterForServices?from_date=${fromDate}&to_date=${toDate}&location_id=${locationId}`
    );
  }

  // trainer active members report
  getTraineesHasCredit(trainerId) {
    this.updateUrlExtention();
    return this.http.get(
      this.baseUrl +
      `backoffice${this.urlExtenssion}/reports/getTraineesHasCredit?trainer_id=${trainerId}`
    );
  }

  // installments report
  getTraineesHasInstallment(fromDate, toDate) {
    this.updateUrlExtention();
    return this.http.get(
      this.baseUrl +
      `backoffice${this.urlExtenssion}/transaction/getInstallmentsWithinDates?from_date=${fromDate}&to_date=${toDate}`
    );
  }
  getComingInstallments() {
    this.updateUrlExtention();
    return this.http.get(
      this.baseUrl +
      `backoffice${this.urlExtenssion}/reports/getComingInstallments`
    );
  }
  getStatusInstallments() {
    this.updateUrlExtention();
    return this.http.get(
      this.baseUrl +
      `backoffice${this.urlExtenssion}/reports/StatusInstallments`
    );
  }

  // membership report
  getMemberShip(fromDate, toDate, membershipId, option, packageId = "") {
    this.updateUrlExtention();
    return this.http.get(
      this.baseUrl +
      `backoffice${this.urlExtenssion}/reports/getMemberShipReportFilter?from_date=${fromDate}&to_date=${toDate}&member_ship_id=${membershipId}&option=${option}&package_id=${packageId}`
    );
  }

  // dashboard reports
  getActiveNonActive() {
    this.updateUrlExtention();
    return this.http.get(
      this.baseUrl +
      `backoffice${this.urlExtenssion}/reports/getActiveNonActive`
    );
  }
  getRenewalTraineesPercentage() {
    this.updateUrlExtention();
    return this.http.get(
      this.baseUrl +
      `backoffice${this.urlExtenssion}/reports/getRenewalTraineesPercentage`
    );
  }
  getMalesFemales() {
    this.updateUrlExtention();
    return this.http.get(
      this.baseUrl + `backoffice${this.urlExtenssion}/reports/getMalesFemales`
    );
  }
  getListMostServiceUsed() {
    this.updateUrlExtention();
    return this.http.get(
      this.baseUrl +
      `backoffice${this.urlExtenssion}/reports/getListMostServiceUsed`
    );
  }
  getRevenueExtraServices() {
    this.updateUrlExtention();
    return this.http.get(
      this.baseUrl +
      `backoffice${this.urlExtenssion}/reports/getRevenueExtraServices`
    );
  }
  getRevenueMemberships(locationId) {
    this.updateUrlExtention();
    return this.http.get(
      this.baseUrl +
      `backoffice${this.urlExtenssion}/reports/getMemberShipsRevenue?location_id=${locationId}`
    );
  }

  // sales reports
  getSalesReportFilter(
    startDate: string,
    endDate: string,
    salesmanId: string,
    locationId: string = ""
  ) {
    this.updateUrlExtention();
    return this.http.get(
      this.baseUrl +
      `backoffice${this.urlExtenssion}/reports/getSalesReportFilter?from_date=${startDate}&to_date=${endDate}&location_id=${locationId}&sales_id=${salesmanId}`
    );
  }
  //membership renewal
  getMembershipRenewalFilter(
    startDate: string,
    endDate: string,
    membershipId: string = "",
    packageId: string = "",
    renualStatus: string = ""
  ) {
    this.updateUrlExtention();
    return this.http.get(
      this.baseUrl +
      `backoffice${this.urlExtenssion}/reports/getRenewalMemberShipReportFilter?from_date=${startDate}&to_date=${endDate}&membership_id=${membershipId}&package_id=${packageId}&renewable_status=${renualStatus}`
    );
  }
  //challenge credit
  getChallengeCreditFilter(
    startDate: string,
    endDate: string,
    locationId: string = ""
  ) {
    this.updateUrlExtention();
    return this.http.get(
      this.baseUrl +
      `backoffice${this.urlExtenssion}/reports/getChallengeCreditReportFilter?from_date=${startDate}&to_date=${endDate}&location_id=${locationId}`
    );
  }
  //challenge report
  getChallengeReport(
    locationId: any = null,
    challengeId: any = null,
    trainee_id: any = ""
  ) {
    this.updateUrlExtention();
    return this.http.get(
      this.baseUrl +
      `backoffice${this.urlExtenssion
      }/reports/getCountChallengeReport?location_id=${locationId}&challenge_id=${challengeId}${trainee_id && "&trainee_id=" + trainee_id
      }`
    );
  }

  //session credit
  getSessionCreditFilter(
    startDate: string,
    endDate: string,
    locationId: string = "",
    services: any = []
  ) {
    let params = {
      start_date: startDate,
      end_date: endDate,
      location_id: locationId,
    };
    if (services.length > 0) {
      services.map((el, i) => {
        params[`service_ids[${i}]`] = el;
      });
    }
    this.updateUrlExtention();
    return this.http.get(
      this.baseUrl +
      `backoffice${this.urlExtenssion}/reports/getReservedSessionReport`,
      { params }
    );
  }

  //upcoming membership
  getMembershipActive(startDate: any) {
    this.updateUrlExtention();
    return this.http.get(
      this.baseUrl +
      `backoffice${this.urlExtenssion
      }/reports/getCountForPackageReportMembership?date=${startDate}`
    );
  }

  //upcoming membership
  getRejectedRefund() {
    this.updateUrlExtention();
    return this.http.get(
      this.baseUrl +
      `backoffice${this.urlExtenssion
      }/getRejectedRefund`
    );
  }

}
